import React from "react";
import {Link} from "react-router-dom";

const NavbarRefs = ({link, isActiveMenu, page, img, editMenu}) => {

    return(
        <>
            <div className='button-ref'>
                <div className="button-line button-line_top"></div>
                <div className="button-line button-line_right"></div>
                <div className="button-line button-line_bottom"></div>
                <div className="button-line button-line_left"></div>

                <div className={'navbar__ref'}>
                    {!isActiveMenu ? <Link to={link}><img src={img} alt=""/></Link> :
                        <Link to={link} onClick={() => editMenu(false)}><img src={img} alt=""/><span className='navbar__name-ref additional-text'>{page}</span></Link>
                    }
                </div>
            </div>
        </>
    )
};

export default NavbarRefs